export type ProfileAction = 'suspend' | 'activate' | 'remove';

interface ConfirmProfileActionModalProps {
  action: ProfileAction;
  displayName: string;
  contextLabel?: string;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function ConfirmProfileActionModal({
  action,
  displayName,
  contextLabel = 'team',
  loading,
  onClose,
  onConfirm,
}: ConfirmProfileActionModalProps) {
  const title = action === 'suspend'
    ? 'Suspend User'
    : action === 'activate'
      ? 'Activate User'
      : 'Remove User';

  const message = action === 'suspend'
    ? `Suspend ${displayName}? They will lose access until reactivated.`
    : action === 'activate'
      ? `Activate ${displayName}? They will regain access to this ${contextLabel}.`
      : `Remove ${displayName} from this ${contextLabel}?`;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-lg w-full max-w-sm mx-4">
        <div className="px-6 pt-6 pb-4">
          <h2 className="text-lg font-bold text-gray-900 mb-2">{title}</h2>
          <p className="text-sm text-gray-600">{message}</p>
        </div>
        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-100">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={loading}
            onClick={onConfirm}
            className={`px-4 py-2 text-sm font-medium text-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed transition-colors ${
              action === 'remove' ? 'bg-red-600 hover:bg-red-700' : 'bg-blue-600 hover:bg-blue-700'
            }`}
          >
            {loading ? 'Processing...' : 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
}
